import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyCourseItemComponent } from './my-course-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { DaButtonModule } from '../da-button';
import { InfoPackageModule } from '@draeger-academy/presentation/lib/modules/info-package';

@NgModule({
    declarations: [MyCourseItemComponent],
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        LocalizeRouterModule,
        DaButtonModule,
        DaLinkModule,
        DaProgressiveImageModule,
        InfoPackageModule
    ],
    providers: [],
    exports: [MyCourseItemComponent]
})
export class MyCourseItemModule {
    constructor() {}

    ngInit() {}
}
